const crmErrorKeyPattern = /^(?:crm(?:-bridge)?|service-connection|workspace-access)\.[A-Za-z0-9._-]+$/;

export function translateCrmRequestError(translate, error, fallbackKey) {
    const message = String(error?.message || "").trim();
    return translate(crmErrorKeyPattern.test(message) ? message : fallbackKey);
}
